<script setup lang="ts">
import range from 'lodash/range';
import { ref, watch } from 'vue';

const quantity = defineModel<number>({ required: true });

const altQuantity = ref(false);
watch(quantity, (val) => {
  altQuantity.value = val >= 10;
});
</script>

<template>
  <div class="quantity-container">
    <h6 class="side-bar-title">Quantity</h6>
    <div class="quantity">
      <label for="quantity" />
      <select
        v-if="!altQuantity"
        v-model="quantity"
        aria-label="quantity"
        class="arrow-indicator"
        data-test="quantity-options"
        :disabled="altQuantity"
        id="quantity"
        name="quantity"
      >
        <option :value="val" v-for="val in range(1, 10)" :key="val">{{ val }}</option>
        <option :value="10">more...</option>
      </select>
      <input
        v-if="altQuantity"
        v-model.number="quantity"
        data-test="more-quantity"
        min="1"
        name="quantity"
        required
        type="number"
      />
    </div>
  </div>
</template>
